import React, { Component, Fragment } from 'react';
import logo from 'components/assets/img/logo/pks-oslo.png';
import Booking from '../booking/Booking';
import AboutProject from './home/components/AboutProject';
import Testimonials from './home/components/Testimonials';
import { startFromBooking } from 'components/actions/bookingActions';
import withRouter from 'components/components/common/withRouter';
import { connect } from 'react-redux';
import T from 'components/common/translations/Translate';
import isWindow from 'components/common/helpers/isWindow';

class MainPage extends Component {

  render() {
    return (
      <Fragment>
        <section className="booking-wrap">
          <div className="booking">
            <div className="booking__airport">
              <div className="booking__airport-wrap">
                <div className="booking__airport-desc">
                  <img src={logo} alt="PKS Oslo" />
                  <p className="booking__subtitle"><T>content.landing.homepage.mainpage.title</T></p>
                  <h1>
                    <span><T>content.landing.homepage.mainpage.subtitleFirst</T></span>
                    <span><T>content.landing.homepage.mainpage.subtitleSecond</T></span>
                  </h1>
                </div>
              </div>

              <span className="cloud cloud--top"></span>
              <span className="cloud cloud--middle"></span>
              <span className="cloud cloud--bottom"></span>
            </div>

            <div id="booking" className="booking__form">
              <div className="booking__form-desc">
                {isWindow && (
                  <Booking
                    onlyMobile={false}
                    layoutLp={true}
                  />)
                }
              </div>
            </div>
          </div>
        </section>
        <AboutProject />
        <Testimonials locale={this.props.locale} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    startFromBooking: state.booking.startFromBooking
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    { startFromBooking }
  )(MainPage)
);
